clock.$inject = ['$rootScope', '$interval'];

function clock($rootScope, $interval) {

  this.everyMinute = function(callback) {
    var minutes = new Date().getMinutes();

    var interval = $interval(function() {
      if (minutes !== new Date().getMinutes()) {
        minutes = new Date().getMinutes();
        callback();
      }
    }, 1000, null, false);

    $rootScope.$on('$routeChangeStart', function() {
      $interval.cancel(interval);
    });

  };

}

module.exports = clock;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/services/clock.js
 ** module id = 194
 ** module chunks = 1
 **/